import { render, staticRenderFns } from "./ItemCollections.vue?vue&type=template&id=1302b172&"
import script from "./ItemCollections.vue?vue&type=script&lang=js&"
export * from "./ItemCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports